<template>
   <span class="items-center">
    <feather-icon v-if="!hideIcon" icon="CalendarIcon" svgClasses="h-3 w-3" class="mr-1"/>
    <span v-if="isMetaDate">
      {{value}}
    </span>
    <span v-else>
      <span :class="redOverdue && overdue && 'text-danger'" >{{dateTime | dateWord}}</span><span v-if="moreThanOneDayOverdue && showOverdueDays" class="ml-1 text-xs">({{overdueText}} ago)</span>
    </span>
 </span>
</template>
<script>

import { midnight, isPast, daysFromDate, isMetadate, parseInCurrentTimezone, getDateObject } from '@/helpers/date'

export default {
  components: {
  },
  props: ['value', 'hideIcon', 'showOverdueDays', 'redOverdue'],

  computed: {
    isMetaDate () {
      return isMetadate(this.value)
    },
    dateTime () {
      return getDateObject(this.value)
    },
    overdue () {
      return isPast(this.dateTime)
    },
    moreThanOneDayOverdue () {
      return isPast(this.dateTime) && this.daysAgo > 1
    },
    daysAgo () {
      return daysFromDate(this.dateTime)
    },
    overdueText () {
      const daysAgo = this.daysAgo

      if (daysAgo === 1) {
        return '1 day'
      } else {
        return `${daysAgo} days`
      }
    }
  },
}
</script>
